import { connect } from 'react-redux';
import { compose } from 'redux';
import moment from 'moment';
import withContent from '../../../containers/withContent';
import chapsPaymentContent from '../ChapsPayments/chapsPayment.content';
import Payment from '../../../../src/fasterPayments/components/Payments/Payment';
import {
	chapsUpdatePayment,
	chapsDeletePayment,
	updateAllChapsDates,
	updateAllChapsFromAccounts,
} from '../../../../src/states/chaps/actions';
import { resetPaymentAuthorisation } from '../../../../src/states/payments/actions';
import { initValidation, updateValidation, hideErrorMsg, removeKey } from '../../../../src/states/validation/actions';
import { getValidationRowState } from '../../../../src/states/validation/selectors';
import {
	getAccountIsBillerOrCreditCard,
	isFutureDatedPaymentUnsupported,
} from '../../../../src/states/accounts/selectors';
import { isPayee, isSingleUsePayee, hasRefChangedFromDefault } from '../../../../src/states/payees/selectors';
import { calcMaxAmountForPaymentType } from '../../../../src/states/modes/selectors';
import { getChapsReference } from '../../../states/chaps/selectors';

const mapState = (state, props) => ({
	validations: getValidationRowState(state, props.id),
	isRefDisabled: getAccountIsBillerOrCreditCard(state, props.toAccount),
	isToPayee: isPayee(state, props.toAccount),
	isRefUpdated: (toAccount, reference) => hasRefChangedFromDefault(state, toAccount, reference),
	isToSingleUsePayee: isSingleUsePayee(state, props.toAccount),
	isFutureDatedPaymentUnsupported: isFutureDatedPaymentUnsupported(state, props.fromAccount, props.toAccount),
	optionalReference: props.chapsMode,
	maxAmountForPaymentType: calcMaxAmountForPaymentType(state),
	chapsReference: getChapsReference(state, props.id),
});

const mapDispatch = (dispatch, props) => ({
	handleSelectFromAccount: (fromAccountId) => {
		if (props.updateAllOnChange) return dispatch(updateAllChapsFromAccounts({ fromAccountId }));
		dispatch(
			chapsUpdatePayment({
				paymentId: props.id,
				formKey: 'fromAccount',
				value: fromAccountId,
			})
		);
		dispatch(
			chapsUpdatePayment({
				paymentId: props.id,
				formKey: 'amount',
				value: '',
			})
		);
		dispatch(
			chapsUpdatePayment({
				paymentId: props.id,
				formKey: 'reference',
				value: '',
			})
		);
		const offset = props.type === 'repeating' ? 1 : 0;
		return dispatch(chapsUpdatePayment({ paymentId: props.id, formKey: 'date', value: moment().add(offset, 'day') }));
	},
	handleAmountBlur: (value = '') => {
		if (props.amount !== value) {
			dispatch(
				chapsUpdatePayment({
					paymentId: props.id,
					formKey: 'amount',
					value,
				})
			);
		}
	},
	handleDateChange: (date = moment()) => {
		if (props.updateAllOnChange) dispatch(updateAllChapsDates({ date }));
		else dispatch(chapsUpdatePayment({ paymentId: props.id, formKey: 'date', value: date }));
	},
	handleChapsRefChange: (chapsRef) =>
		dispatch(chapsUpdatePayment({ paymentId: props.id, formKey: 'chapsReference', value: chapsRef })),
	handleRefChange: (ref) => dispatch(chapsUpdatePayment({ paymentId: props.id, formKey: 'reference', value: ref })),
	initValidation: () =>
		dispatch(
			initValidation({
				id: props.id,
				templateMode: props.templateMode,
			})
		),
	updateValidation: (key, isValid) =>
		dispatch(
			updateValidation({
				id: props.id,
				key,
				isValid,
			})
		),
	hideErrorMsg: (key) =>
		dispatch(
			hideErrorMsg({
				id: props.id,
				key,
			})
		),
	resetPaymentAuthorisation: () =>
		dispatch(
			resetPaymentAuthorisation({
				id: props.id,
			})
		),
	handleRemovePayment: () => {
		dispatch(chapsDeletePayment(props.id));
		dispatch(removeKey({ id: props.id }));
	},
});

export default compose(connect(mapState, mapDispatch), withContent({ content: chapsPaymentContent }))(Payment);
